module.exports = __webpack_public_path__ + "static/media/29.03283561.jpeg";